export default "__VITE_ASSET__DIdXsnXd__"